/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Configuration creation request containing all necessary data.
 * 
 * **Required Fields:**
 * - `configurationType` - Type of configuration (SECURITY_POLICY, INTEGRATION, etc.)
 * - `scope` - Configuration scope (SYSTEM, TENANT, DEFAULT)
 * - `name` - Human-readable name for the configuration
 * - `configurationData` - JSON object containing configuration values
 * 
 * **Optional Fields:**
 * - `description` - Detailed description of the configuration
 * - `tenantId` - Tenant ID (required for TENANT scope)
 * - `default` - Whether this is a default configuration template
 * 
 * **Configuration Data Validation:**
 * - All fields are validated against JSON schemas
 * - Required fields depend on configuration type
 * - Data types and constraints are enforced
 * - Nested objects and arrays are supported
 * 
 * @export
 * @interface CreateConfigurationRequest
 */
export interface CreateConfigurationRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateConfigurationRequest
     */
    configurationType?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateConfigurationRequest
     */
    scope?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateConfigurationRequest
     */
    tenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateConfigurationRequest
     */
    scopeEntityId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateConfigurationRequest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateConfigurationRequest
     */
    description?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof CreateConfigurationRequest
     */
    configurationData?: { [key: string]: any; };
    /**
     * Optional JSON metadata (e.g. publisherDisplayName, restrictEditToPublisher for PUBLISHED_MDR_DASHBOARD)
     * @type {{ [key: string]: any; }}
     * @memberof CreateConfigurationRequest
     */
    metadata?: { [key: string]: any; };
    /**
     * 
     * @type {boolean}
     * @memberof CreateConfigurationRequest
     */
    _default?: boolean;
}

/**
 * Check if a given object implements the CreateConfigurationRequest interface.
 */
export function instanceOfCreateConfigurationRequest(value: object): value is CreateConfigurationRequest {
    return true;
}

export function CreateConfigurationRequestFromJSON(json: any): CreateConfigurationRequest {
    return CreateConfigurationRequestFromJSONTyped(json, false);
}

export function CreateConfigurationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateConfigurationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'configurationType': json['configurationType'] == null ? undefined : json['configurationType'],
        'scope': json['scope'] == null ? undefined : json['scope'],
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'scopeEntityId': json['scopeEntityId'] == null ? undefined : json['scopeEntityId'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'configurationData': json['configurationData'] == null ? undefined : json['configurationData'],
        'metadata': json['metadata'] == null ? undefined : json['metadata'],
        '_default': json['default'] == null ? undefined : json['default'],
    };
}

export function CreateConfigurationRequestToJSON(json: any): CreateConfigurationRequest {
    return CreateConfigurationRequestToJSONTyped(json, false);
}

export function CreateConfigurationRequestToJSONTyped(value?: CreateConfigurationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'configurationType': value['configurationType'],
        'scope': value['scope'],
        'tenantId': value['tenantId'],
        'scopeEntityId': value['scopeEntityId'],
        'name': value['name'],
        'description': value['description'],
        'configurationData': value['configurationData'],
        'metadata': value['metadata'],
        'default': value['_default'],
    };
}

